<template>
  <!-- Äußeren Container so definieren, dass er den ganzen Bildschirm (oder einen definierten Bereich) einnimmt -->
  <div class="p-5 bg-trader-gray rounded flex flex-col gap-2 flex-grow">

    <!-- Info-Bereich -->
    <div class="flex flex-col text-black pb-5">
      <h2 class="text-2xl font-bold">Standard JSON Export</h2>
    </div>

    <!-- SELECTS (und weitere Eingaben) -->
    <div class="flex flex-col w-full gap-2">

      <!-- Projekt -->
      <div class="flex">
        <span class="p-1 w-[150px]">Projekt:</span>
        <select
            class="outline-0 border border-bg-trader-input-border border-header p-1 flex-grow shadow-inner-2 text-gray-500"
            v-model="projectId">
          <option v-for="project in projectData.projects"
                  :key="project.projectId"
                  :value="project.projectId">
            {{ project.name }}
          </option>
        </select>
      </div>

      <!-- Magazine -->
      <div class="flex">
        <span class="p-1 w-[150px]">Magazine:</span>
        <select v-model="magazineId"
                class="outline-0 border border-bg-trader-input-border border-header p-1 flex-grow shadow-inner-2 text-gray-500">
          <option v-for="magazine in magazineData"
                  :key="magazine.magazineId"
                  :value="magazine.magazineId">
            {{ magazine.name }}
          </option>
        </select>
      </div>
      
    </div>

      <!-- Buttons am Ende -->
      <div class="flex gap-1 justify-between items-center">
        <button class="text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px]">
          Abbrechen
        </button>
        <button @click="JSONExport"
                class="text-trader-dark-red text-center bg-trader-red hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px]">
          Jetzt importieren
        </button>
      </div>

  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus.js";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import axios from "axios";
import Spinner from "@/components/Base/Spinner.vue";
import SignalBus from "@/application/SignalBus";
import {mutation, query} from "@/graphql";
import ShowReport from "@/components/Dialogs/ShowReport.vue";
import TRProgress from "@/components/Base/v2/TRProgress.vue";
import {mapState} from "vuex";

export default {
  components: {TRProgress, Spinner},

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      projectData: [],
      projectId: 0,
      magazineId: 0,
      magazineData: [],
    };
  },
  computed: {
    ...mapState('user', ['userData']),
  },
  mounted() {
    this.getProjects();
  },
  created() {
    this.projectId = this.$route.params.projectId;
    this.magazineId = this.$route.params.magazineId;
  },
  methods: {

    async JSONExport() {
      const [_, err] = await mutation.JSONExport(this.magazineId );
      if (err) {
        console.error('Fehler beim Importieren der Excel-Datei:', err);
      }
    },
    async getProjects() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query GetProjectDetails {
              projects {
                projectId
                name
                magazines {
                  magazineId
                  name
                  numberOfPages

                }
              }
            }
          `
        });
        this.projectData = response.data;
        this.magazineData = [];
        if (this.projectId !== 0) {
          this.projectData.projects.forEach((project) => {
            if (project.projectId == this.projectId) {
              this.magazineData.push(project.magazines);
            }
          });
        } else {
          this.projectData.projects.forEach((project) => {
            this.magazineData.push(...project.magazines);
          });
        }

        this.magazineData = this.magazineData.flat();


      } catch (error) {
        console.error("Fehler beim Abrufen der Projektdaten:", error);
      }
    },

    deleteTrue() {
      eventBus.closeModal();
      try {
        if (this.value.onAccept) {

          eventBus.closeModal();
        }
      } catch (e) {
        console.error(e);
      }
    },
    deleteFalse() {
      eventBus.closeModal();
      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  watch: {
    projectId: 'getProjects',
    magazineId: 'getProjects',
    '$route.params': {
      handler: function (params) {
        if (this?.projectId != params?.projectId) {
          this.projectId = params.projectId;
        }
        if (this?.magazineId != params?.magazineId) {
          this.magazineId = params.magazineId;
        }
      },
      deep: true
    }

  }
};
</script>
